import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import {
  JobKodawariCountType,
  JobKodawariType,
  KODAWARI,
} from '@doda/common/src/constants/seo/kodawari';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { createPreBtn } from '@doda/common/src/logics/JobContent/createPreBtn';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { toNumber } from '@doda/common/src/utils/toNumber';

/**
 * 棒グラフ用配列からidが入ったオブジェクトとidだけの配列を返す
 * @param kodwariconstants こだわり項目名配列
 * @param rankingListCount 求人数配列
 * @param rankingListName こだわり項目名配列
 * @returns id、名前、求人数が入ったオブジェクトとidだけの配列を返す
 */
export const createJobKodawariCount = (
  kodwariconstants: JobKodawariType[],
  rankingListCount: string[] | number[],
  rankingListName: string[] | number[]
) => {
  const jobCountValue: JobKodawariCountType[] = [];
  kodwariconstants.forEach((kodawari) => {
    for (let i = 0; i < rankingListCount.length; i += 1) {
      if (rankingListName[i] === kodawari.text) {
        jobCountValue.push({
          value: kodawari.value,
          text: kodawari.text,
          count: toNumber(rankingListCount[i]),
        });
      }
    }
  });
  const kodawariIdList: string[] = [];
  jobCountValue.forEach((kodawari) => {
    return kodawariIdList.push(kodawari.value);
  });
  return { jobCountValue, kodawariIdList };
};

/**
 * 言語・仕事内容用棒グラフ用配列からidが入ったオブジェクトとidだけの配列を返す
 * @param rankingListCount 求人数配列
 * @param rankingListName こだわり項目名配列
 * @returns id、名前、求人数が入ったオブジェクトとidだけの配列を返す
 */
export const createJobKodawariCountLanguage = (
  rankingListCount: string[] | number[],
  rankingListName: string[] | number[]
) => {
  const jobCountValueLanguageSkillsAndPositions: JobKodawariCountType[] = [];
  const jobCountValueLanguageSkills: JobKodawariCountType[] = [];
  KODAWARI.languageSkills.forEach((kodawari) => {
    for (let i = 0; i < rankingListCount.length; i += 1) {
      if (rankingListName[i] === kodawari.text) {
        jobCountValueLanguageSkills.push({
          value: kodawari.value,
          text: kodawari.text,
          count: toNumber(rankingListCount[i]),
        });
        jobCountValueLanguageSkillsAndPositions.push({
          value: kodawari.value,
          text: kodawari.text,
          count: toNumber(rankingListCount[i]),
        });
      }
    }
  });
  const jobCountValuePositions: JobKodawariCountType[] = [];
  KODAWARI.positions.forEach((kodawari) => {
    for (let i = 0; i < rankingListCount.length; i += 1) {
      if (rankingListName[i] === kodawari.text) {
        jobCountValuePositions.push({
          value: kodawari.value,
          text: kodawari.text,
          count: toNumber(rankingListCount[i]),
        });
        jobCountValueLanguageSkillsAndPositions.push({
          value: kodawari.value,
          text: kodawari.text,
          count: toNumber(rankingListCount[i]),
        });
      }
    }
  });
  return {
    jobCountValueLanguageSkillsAndPositions,
    jobCountValueLanguageSkills,
    jobCountValuePositions,
  };
};

/**
 * 言語・仕事内容用opクエリ、URL作成処理
 * @param queryParams そのページのクエリパラメータ
 * @param languageSkillsOp 言語opクエリ
 * @param positionsOp 仕事内容opクエリ
 * @returns opクエリ、URL作成処理
 */
export const createOpAndUrl = (
  queryParams: AppQueryParams,
  languageSkillsOp: string[],
  positionsOp: string[]
) => {
  const languageAndPositionsUrl: string[] = [];
  const languageAndPositionsOP: string[] = [];
  languageSkillsOp.forEach((lang) => {
    return languageAndPositionsOP.push(lang);
  });
  positionsOp.forEach((posi) => {
    return languageAndPositionsOP.push(posi);
  });
  languageSkillsOp.forEach((op) => {
    const appQueryParamslanguageSkills = createPreBtn(queryParams);
    if (appQueryParamslanguageSkills.op) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore TODO: op の型は `Item` なのに代入してる値の型は `(string | Item)[]` なので要修正
      appQueryParamslanguageSkills.op = [
        appQueryParamslanguageSkills.op,
        op,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO: a,b の型が `string | Item` で - 演算ができないので要修正
      ].sort((a, b) => a - b);
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore TODO: op の型は `Item | undefined` なのに代入してる値の型は `string` なので要修正
      appQueryParamslanguageSkills.op = op;
    }
    return languageAndPositionsUrl.push(
      makeStaticUrl(
        appQueryParamslanguageSkills,
        DODA_SITE_URL.jobSearchList
      ).replace(/,/g, '%2C')
    );
  });
  positionsOp.forEach((op) => {
    const appQueryParamspositions = createPreBtn(queryParams);
    if (appQueryParamspositions.op) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore TODO: op の型は `Item` なのに代入してる値の型は `(string | Item)[]` なので要修正
      appQueryParamspositions.op = [appQueryParamspositions.op, op].sort(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO: a,b の型が `string | Item` で - 演算ができないので要修正
        (a, b) => a - b
      );
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore TODO: op の型は `Item | undefined` なのに代入してる値の型は `string` なので要修正
      appQueryParamspositions.op = op;
    }
    return languageAndPositionsUrl.push(
      makeStaticUrl(
        appQueryParamspositions,
        DODA_SITE_URL.jobSearchList
      ).replace(/,/g, '%2C')
    );
  });
  return { languageAndPositionsUrl, languageAndPositionsOP };
};
